import React from 'react';
import { observer } from 'mobx-react';
import Icon from '@xo-union/tk-component-icons';
import classnames from 'classnames';
import styles from './checkbox-cell.scss';

const CheckboxCell = observer(props => {
  const { id, checked, onClick } = props;
  const testId = checked ? 'thankyou-checkmark-filled' : 'thankyou-checkmark';

  return (
    <td className={classnames(styles.thankYou)}>
      <div
        role="checkbox"
        className={`${styles.checkbox} ${checked ? styles.checked : ''}`}
        data-testid={`${testId}-${id}`}
        aria-checked={checked}
        onClick={onClick}
        onKeyDown={e => (e.key === 'Enter' ? onClick() : null)}
        tabIndex={0}
      >
        <Icon name="checkmark_mini" size="md" className={styles.icon} />
        <label htmlFor={id} />
      </div>
    </td>
  );
});

export default CheckboxCell;
